import { useTranslation } from 'react-i18next';
import { ClipboardList } from 'lucide-react';

type DropdownEmptyStateProps = {
  isSearchResult?: boolean;
  title?: string;
};

export const DropdownEmptyState = (props: DropdownEmptyStateProps) => {
  const { isSearchResult = false, title } = props;
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center gap-1 py-9 text-center">
      <ClipboardList className="text-muted-foreground block size-5" />
      <span className="text-foreground text-sm font-medium">
        {title ?? t(isSearchResult ? 'Nothing found' : 'No options available')}
      </span>
      <span className="text-muted-foreground block text-xs">
        {t(
          isSearchResult
            ? 'Try changing your search.'
            : 'New options will appear here.',
        )}
      </span>
    </div>
  );
};
